import { getBuyerIdFromCurrentOrder, getOrderDetails, getUserAccess } from '@app/ducks';
import { getIsOrderClosed } from '@app/logic/Orders';
import { fetchCmsBuyerNavigation } from '@app/services/navigationRepository';
import { isEmpty } from '@app/utils/isEmpty';
import { useQuery } from '@tanstack/react-query';
import { Navigation } from '@typings';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

interface Props {
  refetchOnMount?: boolean;
}

export const NAVIGATION_ITEMS_QUERY_KEY = 'navigationItems';

export const useNavigationItems = ({ refetchOnMount }: Props) => {
  const { t } = useTranslation(['cms']);
  const userAccess = useSelector(getUserAccess);
  const orderDetails = useSelector(getOrderDetails);
  const orderBuyerId = useSelector(getBuyerIdFromCurrentOrder);
  const isOrderClosed = getIsOrderClosed(orderDetails.order);

  return useQuery<{
    items: Navigation.UserMenuItem[];
  }>({
    meta: {
      errorMessage: t('cms:fetch_homepage_fail'),
    },
    queryFn: async () => {
      if (userAccess === 'buyer') {
        return fetchCmsBuyerNavigation();
      }

      if (isEmpty(orderBuyerId) || isOrderClosed) {
        return { items: [] };
      }

      return fetchCmsBuyerNavigation(userAccess === 'viewer' ? undefined : orderBuyerId);
    },
    queryKey: [NAVIGATION_ITEMS_QUERY_KEY, { isOrderClosed, orderId: orderDetails.order.order, userAccess }],
    refetchOnMount,
  });
};
